module.exports = __webpack_public_path__ + "img/pack_2.96355e92.jpg";